// extracted by mini-css-extract-plugin
export var carrierTab = "_69-0";
export var carrierTabActive = "_69-1 _69-0";
export var carrierTabInactive = "_69-2 _69-0";
export var carrierTabLabel = "_69-3";
export var carrierTabLabelActive = "_69-4 _69-3";
export var carrierTabLabelInactive = "_69-5 _69-3";
export var carrierTabPercentage = "_69-6";
export var carrierTabPercentageActive = "_69-7 _69-6";
export var carrierTabPercentageInactive = "_69-8 _69-6";
export var carrierTabWinnable = "_69-9";
export var carrierTabWinnableActive = "_69-a _69-9";
export var carrierTabWinnableInactive = "_69-b _69-9";
export var comparisonContainer = "_69-d";
export var missingRateButton = "_69-n";
export var missingRateButtonActive = "_69-o _69-n";
export var missingRateButtonInactive = "_69-p _69-n";
export var missingRateButtonLabel = "_69-q";
export var missingRateButtonLabelActive = "_69-r _69-q";
export var missingRateButtonLabelInactive = "_69-s _69-q";
export var sidebar = "_69-c";
export var strategyButton = "_69-e";
export var strategyButtonActive = "_69-f _69-e";
export var strategyButtonDescription = "_69-k";
export var strategyButtonDescriptionActive = "_69-l _69-k";
export var strategyButtonDescriptionInactive = "_69-m _69-k";
export var strategyButtonInactive = "_69-g _69-e";
export var strategyButtonLabel = "_69-h";
export var strategyButtonLabelActive = "_69-i _69-h";
export var strategyButtonLabelInactive = "_69-j _69-h";
export var unitToggleButton = "_69-t";
export var unitToggleButtonActive = "_69-u _69-t";
export var unitToggleButtonInactive = "_69-v _69-t";
export var unitToggleButtonLabel = "_69-w";
export var unitToggleButtonLabelActive = "_69-x _69-w";
export var unitToggleButtonLabelInactive = "_69-y _69-w";